import requests from "./httpServices";

export const sendTeamInvite = ({ email, name, role, roomId, webhookUrl }) =>
  requests.post("/invitations/send", { email, name, role, roomId, webhookUrl });

export const checkInviteEmail = (email) =>
  requests.post("/invitations/check-email", { email });

export const getInvitation = (token) =>
  requests.get(`/invitations/${token}`);

export const acceptInvitation = (token) =>
  requests.post(`/invitations/${token}/accept`, {});

export const listInvitations = () => requests.get("/invitations");

export const resendInvitation = (invitationId) =>
  requests.post(`/invitations/${invitationId}/resend`, {});

export const updateInvitation = (invitationId, { name, role }) =>
  requests.put(`/invitations/${invitationId}`, { name, role });

export const removeInvitation = (invitationId) =>
  requests.delete(`/invitations/${invitationId}`);
